export const isTeasersEmpty = (props) => !props || Boolean(!props?.teasers?.length);
